// Re-export all sensyn-id API functions using wildcard imports
import * as userApi from '@/api/sensyn-id/generated/user/user';
import * as internalApi from '@/api/sensyn-id/generated/internal/internal';
import * as healthCheckApi from '@/api/sensyn-id/generated/health-check/health-check';
import * as organizationApi from '@/api/sensyn-id/generated/organization/organization';
import * as divisionApi from '@/api/sensyn-id/generated/division/division';

// Re-export types
export * from '@/api/sensyn-id/generated/model';

// Re-export all API functions
export * from '@/api/sensyn-id/generated/user/user';
export * from '@/api/sensyn-id/generated/internal/internal';
export * from '@/api/sensyn-id/generated/health-check/health-check';
export * from '@/api/sensyn-id/generated/organization/organization';
export * from '@/api/sensyn-id/generated/division/division';

// Enhanced function that returns all API functions
export function useSensynIdApi() {
  function useUserApi() {
    return userApi;
  }

  function useInternalApi() {
    return internalApi;
  }

  function useHealthCheckApi() {
    return healthCheckApi;
  }

  function useOrganizationApi() {
    return organizationApi;
  }

  function useDivisionApi() {
    return divisionApi;
  }

  return {
    useUserApi,
    useInternalApi,
    useHealthCheckApi,
    useOrganizationApi,
    useDivisionApi,
  };
}
